import React from "react";
import styles from "./ResourceDemoPreview.module.css";

/**
 * ResourceFeatureImage — A static visual card for Management resource sections.
 * Matches the visual design system of the ResourceDemoPreview, but serves
 * only as a decorative/illustrative image without interactive demo features.
 */
export default function ResourceFeatureImage({ imageSrc, alt }) {
  if (!imageSrc) return null;

  return (
    <div className={styles.demoPreviewBox} style={{ cursor: "default" }}>
      <div className={styles.thumbnailState} style={{ pointerEvents: "none" }}>
        <img
          src={imageSrc}
          alt={alt || "Feature illustration"}
          className={styles.thumbnailImage}
        />
      </div>
    </div>
  );
}
